<form role="form" [formGroup]="questionDifficultyForm">
<h1 mat-dialog-title>QUESTION DIFFICULTY</h1>
<div mat-dialog-content>
  <p>{{data.title}}</p>
  
  <p>
    <mat-form-field appearance="outline">
      <mat-label>Select of Exam Type</mat-label>
      <!-- <input matInput formControlName="name" placeholder="Normal"> -->
      <mat-select formControlName="name">
        <mat-option value="Easy">Easy</mat-option>
        <mat-option value="Normal">Normal</mat-option>
        <mat-option value="Hard">Hard</mat-option>
      </mat-select>
    </mat-form-field>
  </p>
  <p>
    <mat-form-field appearance="outline">
      <mat-label>Description</mat-label>
      <input matInput formControlName="description" placeholder="Standard questions">
    </mat-form-field>
  </p>
  
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Close</button>
  <button mat-button [mat-dialog-close]="" cdkFocusInitial (click)="addQuestionDifficulty()">Save</button>
</div>
</form>